export default __webpack_public_path__ + "946bf899bb9942522b355168591a6a9f.woff";